module.exports = __webpack_public_path__ + "img/oneClickCalculation.b9a7d80a.svg";